import { Controller } from "@hotwired/stimulus";

// TOPの「イベントを探す」カテゴリボタン。
// クリック時点でキーワード欄・エリア選択に入力済みの値があれば、カテゴリ検索のURLに引き継ぐ。
export default class extends Controller {
  static targets = ["word", "pref"];

  navigate(e) {
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;

    e.preventDefault();

    const url = new URL(e.currentTarget.href);
    const word = this.wordTarget.value.trim();
    const pref = this.prefTarget.value;

    if (word) url.searchParams.set("word", word);
    if (pref) url.searchParams.set("pref", pref);

    window.location.href = url.toString();
  }
}
